import { render, staticRenderFns } from "./PhysicalPersonData.vue?vue&type=template&id=769e531c&scoped=true"
import script from "./PhysicalPersonData.vue?vue&type=script&lang=js"
export * from "./PhysicalPersonData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e531c",
  null
  
)

export default component.exports